import { Main } from 'ui/components';
import { ModuleMapFeature } from 'features/Mappers/Module';

/**
 * EquipmentPageFeature - DO NOT DELETE
 *
 * Required by CMS backend to render EquipmentPage document type, which used for Equipment subpages on Website25
 * Solution was made to mirror the previous Sitecore solution that required this setup for equipments
 *
 * WARNING: Multiple equipment-related features exist in this repo for different user groups.
 * Deleting this breaks existing EquipmentPage content for Website25. Verify first before removing
 */
export const EquipmentPageFeature: React.FC<Umbraco.EquipmentPage> = ({ properties, culture }) => {
	const { pageSections } = properties ?? {};

	return (
		<Main>
			{pageSections?.map((sectionModule, index) => (
				<ModuleMapFeature key={index} contentModule={sectionModule} culture={culture} />
			))}
		</Main>
	);
};
